// extracted by mini-css-extract-plugin
export default {"pdf_wrapper":"Pdf_pdf_wrapper__dG70E"};